export function findBasename(historyBasename, currentPathname, transformBasename) {
  // Iterator.prototype.find() is not supported in legacy browsers
  for (const basename of transformBasenames(historyBasename, transformBasename)) {
    if (currentPathname.startsWith(basename)) {
      return basename;
    }
  }
}
function* transformBasenames(historyBasename, transformBasename = basename => basename) {
  if (Array.isArray(historyBasename)) {
    for (const basename of historyBasename) {
      yield transformBasename(basename);
    }
  } else {
    yield transformBasename(historyBasename);
  }
}